import * as MUI from "@material-ui/core";
import * as React from "react";
import { Link } from "react-router-dom";
import LogoBASF from "../icons/LogoBASF";
import { HeaderNavigation } from "../modules/navigation";
import AccountBar from "../components/AccountBar";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import { useAuth } from "../modules/auth";

const styles = (theme: Theme) => {
  const primary50 = (theme.palette.primary as any)[50] as string;
  const primaryMain = theme.palette.primary.main as string;
  return createStyles({
    root: {
      height: 64, // 8px * 8 = 64px
      width: "100%",
      backgroundColor: theme.palette.primary.main,
      backgroundImage: 'url("/assets/images/header_background.png")',
      backgroundRepeat: "no-repeat",
      display: "flex",
      backgroundPositionX: 160,
    },
    toolbar: {
      height: "inherit",
      paddingLeft: 32,
      paddingRight: 32,
      display: "flex",
      justifyContent: "space-between",
      flexShrink: 0,
      flex: "none",
      // eslint-disable-next-line no-magic-numbers
      backgroundImage: `linear-gradient(to right, ${primary50} 60%, ${primaryMain} 1470px)`,
    },
    logo: {
      minWidth: 95,
      minHeight: 35,
      marginTop: 4,
    },
    leftSide: {
      display: "flex",
      alignItems: "center",
    },
    rightSide: {
      display: "flex",
      alignItems: "center",
      color: theme.palette.text.secondary,
    },
    navigation: {
      paddingLeft: 96,
    },
    link: {
      display: "flex",
      justifyContent: "center",
      paddingBottom: 11,
      lineHeight: "16px",
      position: "relative",
      "&:hover": {
        paddingBottom: 9,
        borderBottom: "2px solid #fff",
        textDecoration: "none",
      },
    },
    dotForActiveLink: {
      position: "absolute",
      width: 4,
      height: 4,
      background: "#FFFFFF",
      borderRadius: "2px",
      bottom: 0,
      left: "calc(50% - 2px)",
    },
    notHoverLink: {
      display: "flex",
      justifyContent: "center",
      paddingBottom: 11,
      lineHeight: "16px",
      position: "relative",
      "&:hover": {
        textDecoration: "inherit",
        paddingBottom: 11,
        borderBottom: `inherit`,
      },
    },
  });
};

type Props = WithStyles<typeof styles>;

const Header: React.FC<Props> = (props: Props) => {
  const { classes } = props;
  const [isAuth] = useAuth();

  return (
    <MUI.AppBar className={classes.root}>
      <MUI.Toolbar className={classes.toolbar}>
        <div className={classes.leftSide}>
          <Link to="/" className={classes.logo}>
            <LogoBASF className={classes.logo} />
          </Link>
          {isAuth ? <HeaderNavigation parentClasses={classes} /> : null}
        </div>
        <div className={classes.rightSide}>
          <AccountBar />
        </div>
      </MUI.Toolbar>
    </MUI.AppBar>
  );
};

export default withStyles(styles)(Header);
